/**
 * @generated SignedSource<<83ca7ee6d128f3048a7a5eb83790e5ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SettlementViewDownloadPdfMutation$variables = {
  language: string;
  settlementIdentifier: string;
};
export type SettlementViewDownloadPdfMutation$data = {
  readonly downloadSettlementPdf: {
    readonly filename: string;
    readonly uri: string;
  } | null | undefined;
};
export type SettlementViewDownloadPdfMutation = {
  response: SettlementViewDownloadPdfMutation$data;
  variables: SettlementViewDownloadPdfMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settlementIdentifier"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "language",
            "variableName": "language"
          },
          {
            "kind": "Variable",
            "name": "settlementIdentifier",
            "variableName": "settlementIdentifier"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TemporaryDownload",
    "kind": "LinkedField",
    "name": "downloadSettlementPdf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettlementViewDownloadPdfMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettlementViewDownloadPdfMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ffa29aaad56582d69fdc73182e88d3a2",
    "id": null,
    "metadata": {},
    "name": "SettlementViewDownloadPdfMutation",
    "operationKind": "mutation",
    "text": "mutation SettlementViewDownloadPdfMutation(\n  $settlementIdentifier: String!\n  $language: String!\n) {\n  downloadSettlementPdf(input: {settlementIdentifier: $settlementIdentifier, language: $language}) {\n    uri\n    filename\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbd07e1d1ff2a6f7f3b5415f1d0fa456";

export default node;
